(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'entryRequirements', {
            bindings: {
                content:             '<',
                metadata:            '<'
            },
            templateUrl:  'app/views/partials/content/entry-requirements.html',
            controller:   EntryRequirementsController,
            controllerAs: 'vm',

            renderingOptions: {
                'entry-requirements': {
                    inputs:    [
                        'content="::content.asset_contents"',
                        'metadata="::customData.metadata"'
                    ],
                    classes: [
                        'block-container',
                        'entry-requirements',
                        'centraliser'
                    ],
                    wrapStart: '<div class="centraliser">',
                    wrapEnd:   '</div>'
                }
            },

            renderingOptionsOverrides: {
                nested: {
                    'entry-requirements': {
                        wrapStart:     null,
                        wrapEnd:       null,
                        classes:       null,
                        parentClasses: [ 'block-container', 'entry-requirements' ]
                    }
                }
            }
        });


    /**
     * Pre-processes data for Entry requirements and provides controls to
     * change country of study and (re)fetch more related information.
     *
     * Important: In case any significant changes are made to this component,
     * please re-test according to the https://victoriauniversity.atlassian.net/wiki/spaces/WT/pages/168198145/Blackbox+testing+guide+for+Topics+Programmes#BlackboxtestingguideforTopics&Programmes-EntryRequirements
     *
     * @param {ng.IScope} $scope
     * @param {ng.IQService} $q
     * @param {uistate.State} $state
     * @param {DataService} DataService
     * @param {ContentSwitchingService} ContentSwitchingService
     * @param {LoggerFactory} LoggerFactory
     * @param {SubpagesService} SubpagesService
     * @param {TrackerService} TrackerService
     * @param {Utils} Utils
     * @param {App} App
     * @param {Object} TEXTS
     * @param {Object} CONFIG
     */
    function EntryRequirementsController(
        $scope,
        $q,
        $state,
        DataService,
        ContentSwitchingService,
        LoggerFactory,
        SubpagesService,
        TrackerService,

        Utils,
        App,
        TEXTS,
        CONFIG
    ){

        /** @type {angular.IController} */
        var vm = this;





        /* ===== PRIVATE MEMBERS ============================================ */


        /** @type {Logger} */
        var logger = LoggerFactory.createLogger( 'EntryRequirementsController', false );


        /** @constant */
        var REQUIREMENT_TYPE = {
            PLAIN_WITH_BUTTON: 'plain-with-button',
            PLAIN:             'plain',
        };





        /* ===== EXPOSE TO THE SCOPE ======================================== */


        $scope._     = TEXTS.DEGREE.ENTRY_REQUIREMENTS;
        $scope.TYPE  = REQUIREMENT_TYPE;





        /* ===== EXPOSE TO THE CONTROLLER =================================== */


        /** @const */
        vm.KIS_IMAGE_SRC = CONFIG.UI.PATHS.IMAGES.KIS_LANDSCAPE;

        // Members
        vm.model = {
            selectedLastStudy: ContentSwitchingService.userSettings.lastStudyCountry,
            countriesList:     undefined,
            requirements:      undefined,
        };



        // UI flags
        vm.isInternationalContent     = ContentSwitchingService.isInternational();
        vm.isRequirementsError        = false;


        // Methods
        vm.updateLastStudyCountry    = updateLastStudyCountry;
        vm.trackKisCtr               = TrackerService.logKISClick;




        /* ===== RUN ON INSTANTIATION ======================================= */


        // *MUST BE* present to make `ui-select` directive work properly
        vm.selectConfig           = {
            template:           'select2',
            dropdownAutoWidth:  true
        }


        /** @constructor */
        vm.$onInit = function(){
            // Members
            vm.isPostgradSubpage = SubpagesService.isPostgradSubpage();
            vm.constructAnchor   = Utils.anchorConstructorFactory( vm, 'content', 'heading' );

            normaliseLegacyContent();
            updateRequirementsModel();
            setWatchers();
        };





        /* ===== CONTROLLER'S PUBLIC METHODS ================================ */


        function updateLastStudyCountry() {
            logger.debug( "Updating country of the last study..." );
            ContentSwitchingService.setLastStudyCountry( vm.model.selectedLastStudy );

            ContentSwitchingService.saveSettingsToCookie();

            updateRequirementsModel();
        }





        /* ===== PRIVATE FUNCTIONS ========================================== */


        /**
         * TODO: Remove after content is cleaned up within CMS' API.
         *
         * Transform initial content's model into a structure fully compatible
         * with latest requirements processor.
         *
         * Note: Should run only once during initialisation!
         */
        function normaliseLegacyContent() {
            if ( !vm.content.hasOwnProperty( 'entryRequirements' ) && !vm.content.hasOwnProperty( 'NZ' ) ){
                var normalisedEntryRequirements = [];

                if ( vm.content.hasOwnProperty( 'reqWithLink' ) ){
                    var requirementWithButton = vm.content.reqWithLink;

                    normalisedEntryRequirements.push( {
                        text:   requirementWithButton.content,
                        button: {
                            url:   requirementWithButton.link,
                            label: requirementWithButton.linkText,
                            title: requirementWithButton.linkTitle,
                        }
                    });
                }

                if ( vm.content.hasOwnProperty( 'reqOther' ) && vm.content.reqOther.length !== 0 ){
                    vm.content.reqOther.forEach( function( plainTextRequirement ) {
                        normalisedEntryRequirements.push( plainTextRequirement );
                    });
                }

                // Assign to the source content object to expose to others
                vm.content.entryRequirements = normalisedEntryRequirements;
            }
        }


        function updateRequirementsModelForNZ() {
            // Use NZ if it exists. If not, try to use parent.
            var entryRequirementsSourceObject = ( vm.content.hasOwnProperty( 'NZ' ) && vm.content.NZ.hasOwnProperty( 'entryRequirements' ) ) ? vm.content.NZ.entryRequirements : vm.content.entryRequirements;

            if ( entryRequirementsSourceObject ){
                var entryRequirements = prepareRequirementsFromContent( entryRequirementsSourceObject );

                vm.model.requirements = {
                    entry:   entryRequirements,
                    english: null
                };
            } else {
                logger.error( 'No entry requirements were specified for the student who studies at NZ. Cannot render any requirements!', vm.content );
            }
        }


        function updateRequirementsModelForNonNZCountries() {
            // 1./ Use from `non-NZ country`, if it exists. If not, try to use parent.
            var entryRequirementsSourceObject = ( vm.content.hasOwnProperty( 'nonNzCountries' ) && vm.content[ 'nonNzCountries' ].hasOwnProperty( 'entryRequirements' ) ) ? vm.content[ 'nonNzCountries' ].entryRequirements : vm.content.entryRequirements,

            englishRequirementsSourceObject = ( vm.content.hasOwnProperty( 'nonNzCountries' ) && vm.content[ 'nonNzCountries' ].hasOwnProperty( 'englishRequirements' ) ) ? vm.content[ 'nonNzCountries' ].englishRequirements : vm.content.englishRequirements;

            var entryRequirements = prepareRequirementsFromContent( entryRequirementsSourceObject ),
            englishRequirements   = prepareRequirementsFromContent( englishRequirementsSourceObject );

            vm.model.requirements = {
                entry:   entryRequirements,
                english: englishRequirements
            }
        }


        function updateRequirementsModel() {
            var isLastStudyAtNZ = vm.model.selectedLastStudy.code === 'NZ',
            programmePromise    = null;

            // Resolve the structure
            if ( isLastStudyAtNZ ) {
                updateRequirementsModelForNZ();
            } else {
                updateRequirementsModelForNonNZCountries();

                // 2./ If not available - try to retrieve it from VI's API
                if ( !vm.model.requirements.entry || ( !vm.model.requirements.english && vm.isInternationalContent ) ) {
                    programmePromise = getProgrammePromise();
                }
            }

            // Resets
            vm.isRequirementsError      = false;
            vm.isEntryRequirementFromVI = false;

            var promisesRequests = {
                programme:      programmePromise,
                countriesList:  vm.model.countriesList ? null : ContentSwitchingService.getCountriesList()
            };

            logger.debug( "Fetching countries and programme information to extract entry requirements...", promisesRequests, vm.model.requirements );

            $q.all( promisesRequests )
                .then(
                    function( responses ){
                        if ( responses.countriesList ) {
                            processCountriesListResponse( responses.countriesList );
                        }

                        if ( responses.programme ) {
                            processRequirementsResponse( responses.programme );
                        }
                    }
                ).catch(
                    function( error ) {
                        logger.error( getLogIntro() + "International API failed to return valid response (time out, malformed JSON etc.). International entry requirements WILL NOT be shown...", error );
                        vm.isRequirementsError = true;
                    }
                );

            function processCountriesListResponse( countries ) {
                if ( !countries ) return;

                vm.model.selectedLastStudy = ContentSwitchingService.userSettings.lastStudyCountry;
                vm.model.countriesList     = countries;
            }
        }


        /**
         * @param {Object} contentObject
         *
         * @return {Object|null}
         */
        function prepareRequirementsFromContent( requirementsList ) {
            if ( !requirementsList ) return null;

            var preparedRequirementsList = [];

            requirementsList.forEach( function( entryRequirementItem ) {
                // Normalise to requirements types
                if ( angular.isString( entryRequirementItem ) ){
                    // Standard plain text *only*
                    preparedRequirementsList.push({
                        type: REQUIREMENT_TYPE.PLAIN,
                        text: entryRequirementItem
                    });
                } else if ( angular.isObject( entryRequirementItem ) && entryRequirementItem.hasOwnProperty( 'button' ) ) {
                    // More complex object - button
                    preparedRequirementsList.push({
                        type: REQUIREMENT_TYPE.PLAIN_WITH_BUTTON,
                        text:   entryRequirementItem.text,
                        button: entryRequirementItem.button
                    });
                } else {
                    logger.warn( "Unknown type of an entry requirement (`%s`) - accepts either plain string, or Object with `text` and `button` attributes. Will not render this requirement.", typeof entryRequirementItem, entryRequirementItem );
                }
            });

            return ( preparedRequirementsList.length ) ? preparedRequirementsList : null;
        }


        function setWatchers() {
            $scope.$watch( 'ContentSwitchingService.contentType', function() {
                vm.isInternationalContent = ContentSwitchingService.isInternational();
            });

            $scope.$watch( function() {
                return ContentSwitchingService.userSettings.lastStudyCountry; }, function( newLastStudyCountry ) {
                if ( newLastStudyCountry && newLastStudyCountry !== vm.model.selectedLastStudy ) {
                    vm.model.selectedLastStudy = newLastStudyCountry;
                    updateRequirementsModel();
                }
            });
        }


        function processRequirementsResponse( requirementsResponse ){
            if ( requirementsResponse.hasOwnProperty( 'data' ) && requirementsResponse.data.programme ){
                var requirementObject = requirementsResponse.data.programme;

                if ( !vm.model.requirements.entry && requirementObject.minEntryReqOr.length > 0 ) {
                    vm.model.requirements.entry = requirementObject.minEntryReqOr.map( function( entryRequirement ) {
                        return {
                            type: REQUIREMENT_TYPE.PLAIN,
                            text: entryRequirement
                        };
                    })

                    vm.isEntryRequirementFromVI = true;
                }

                if ( !vm.model.requirements.english && vm.isInternationalContent && requirementObject.englishReqOr.length > 0 ) {
                    vm.model.requirements.english = requirementObject.englishReqOr.map( function( englishRequirement ) {
                        return {
                            type: REQUIREMENT_TYPE.PLAIN,
                            text: englishRequirement
                        };
                    })
                }

                logger.ok( ( App.isPublicMode() ? '' : getLogIntro() ) + "Successfully received!" , vm.model.requirements );
            } else {
                logger.error( getLogIntro() + "The API code or the code of Nationality country (%s) are returning an invalid response. Entry requirements from International API WILL NOT be shown...", ContentSwitchingService.userSettings.nationalityCountry.code, requirementsResponse );
                vm.isRequirementsError = true;
            }
        }


        /**
         * Generates logging introduction with custom information based on
         * the given entry requirements type (nested/embedded vs. native).
         */
        function getLogIntro() {
            try {
                var logIntro = '';

                if ( $scope.$parent.mode && $scope.$parent.mode === 'nested' ) {
                    // Inside a sub-qualification (~ nested)
                    logIntro = '{NESTED} ';
                } else {
                    // As a top-level component
                    logIntro = '{TOP-LEVEL} ';
                }

                logIntro += 'Entry requirements (International API) for `' + vm.metadata.name + '`: \n' +
                ' > Qual. code -> API code: ' + vm.metadata.code + ' -> ' + vm.metadata.internationalApiCode +  '\n' +
                ' > Country code of last study: ' + ContentSwitchingService.userSettings.lastStudyCountry.code + '\n\n';
            } catch ( err ) {
                logger.error( "Rich log message could not be constructed.", err );
            }

            return logIntro;
        }


        /**
         * @returns {Promise<Object>|null}
         */
        function getProgrammePromise() {
            if ( vm.metadata && vm.metadata.internationalApiCode ){
                return DataService.getInternationalProgramme( vm.metadata.internationalApiCode, ContentSwitchingService.userSettings.lastStudyCountry.code );
            } else if ( !vm.metadata ) {
                logger.error( "`Metadata` have not been provided to the component - Cannot display entry requirements", vm.metadata );
            } else {
                logger.error( "Missing `%s`'s API code in `metadata.internationalApiCode` attribute - Cannot display entry requirements.", vm.metadata.name, vm.metadata );
            }

            return null;
        }
    }


    EntryRequirementsController.$inject = [ '$scope',  '$q', '$state', 'DataService', 'ContentSwitchingService', 'LoggerFactory', 'SubpagesService', 'TrackerService', 'Utils', 'App', 'TEXTS', 'CONFIG' ];
})();
